import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UpdateUserCommand } from './user-command.types';

@Injectable({
    providedIn: 'root'
})
export class UserCommandService {
    private readonly _http = inject(HttpClient);

    updateUser(command: UpdateUserCommand): Observable<void> {
        return this._http.put<void>('api/users/me', command);
    }
}
